module.exports = __webpack_public_path__ + "red.jpg?9106c1a896f778061f4778570744ef1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar-info/red.jpg
// module id = 490
// module chunks = 1